import * as yup from "yup";

const addAndChangeSchemaSprint = (translate: Function) => yup.object().shape({
	pra003Titulo: yup.string().required(translate("Título é requerido")),
	pra003Dtiniest: yup.date()
		.required(translate("Data inicial é requerida"))
		.typeError(translate("Data inicial com data inválida")),
	pra003Dtfimest: yup.date()
		.required(translate("Data final é requerida"))
		.typeError(translate("Data final com data inválida"))
});

export default addAndChangeSchemaSprint ;
